import styled from 'styled-components';

export const SIntro = styled.p`
    margin-bottom: 2rem;
`;

export const SCaptcha = styled.div`
    margin: 1rem 0 2rem;
`;

export const SFormError = styled.p`
    margin-bottom: 1.5rem;
    color: ${({ theme }) => theme.color.error.main};
    font-weight: bold;
`;

export const SNotice = styled.p`
    margin-top: 1.5rem;
    font-size: 1.2rem;

    a {
        text-decoration: underline;
    }
`;

export const SSuccess = styled.p`
    margin-bottom: 1.5rem;
    font-weight: bold;
`;
